import React from "react";
// @ts-ignore
import ListGroup from 'react-bootstrap/ListGroup';
import { Accordion } from "react-bootstrap";

import AccordionBody from "react-bootstrap/esm/AccordionBody";

import Conectividade from '../../../../../assets/images/fiber.png';
import Checklist from '../../../../../assets/images/checklist.png';
import ChecklistPurchase from "../ChecklistPurchase";

import './styles.css';

const ResidencialPlus = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-sm-12 col-md-4 title">
          <h3>Plano de Internet de 60 MEGAS</h3>
          <img src={Conectividade} alt="foto"></img>
        </div>
        <div className="col-sm-12 col-md-8 alerta">
          <Accordion>
            <Accordion.Item eventKey="0" className="accordion-list">
              <Accordion.Header><h5>1. Internet rápida de 60 megas:</h5></Accordion.Header>
              <AccordionBody>
                Oferecemos uma velocidade de conexão adequada para tarefas do dia
                a dia, como navegar na web, assistir vídeos, enviar e-mails e acessar redes sociais, etc.
              </AccordionBody>
            </Accordion.Item>
            <Accordion.Item eventKey="1" className="accordion-list">
              <Accordion.Header><h5>2. Ideal para até 6 dispositivos:</h5></Accordion.Header>
              <AccordionBody>
                O plano GigaPlus é perfeito para residências com  um número
                maior de dispositivos conectados simultaneamente, como smart tvs, vídeo game, smartphones, tablets e notebooks.
              </AccordionBody>
            </Accordion.Item>
            <Accordion.Item eventKey="2" className="accordion-list">
              <Accordion.Header><h5>3. Navegação rápida e confiável:</h5></Accordion.Header>
              <AccordionBody>
                Tenha uma experiência de navegação suave, com menor probabilidade
                de quedas de conexão e lentidão durante a navegação na web.
              </AccordionBody>
            </Accordion.Item>
            <Accordion.Item eventKey="3" className="accordion-list">
              <Accordion.Header><h5>4. Suporte técnico:</h5></Accordion.Header>
              <AccordionBody>
                Nossa equipe de suporte técnico está disponível para ajudar em caso de
                problemas ou dúvidas relacionadas à conexão de internet.
              </AccordionBody>
            </Accordion.Item>
            <Accordion.Item eventKey="4" className="accordion-list">
              <Accordion.Header><h5>5. Internet Robusta:</h5></Accordion.Header>
              <AccordionBody>
                O plano GigaPlus oferece uma opção acessível para aqueles que desejam ter uma conexão
                robusta de internet para atividades que exige maior consumo de banda.
              </AccordionBody>
            </Accordion.Item>
            <Accordion.Item eventKey="5" className="accordion-list">
              <Accordion.Header><h5>6. Garantia de qualidade:</h5></Accordion.Header>
              <AccordionBody>
                A Gigabyte Telecom é conhecida por oferecer serviços confiáveis e de
                qualidade, garantindo uma ótima experiência de Internet em fibra Óptica.
              </AccordionBody>
            </Accordion.Item>
            <Accordion.Item eventKey="6" className="accordion-list">
              <Accordion.Header><h5>7. Importante:</h5></Accordion.Header>
              <AccordionBody>
                Obs. Caso o cliente possua a necessidade de conectar dezenas de dispositivos,
                ofereça a ele o plano de 400 MEGAS
              </AccordionBody>
            </Accordion.Item>
            <Accordion.Item eventKey="7" className="accordion-list">
              <Accordion.Header><h5>8. Dúvidas:</h5></Accordion.Header>
              <AccordionBody>
                <span>Informações não contidas neste informativo, favor consultar seu supervisor.</span>
              </AccordionBody>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>
      <br />
      <hr />
      <br />
      <div className="row">
        <div className="col-sm-12 col-md-6">
          <h5>Esse checklist ajudará nossos atendentes a conduzir o atendimento de forma eficiente, fornecendo todas as informações relevantes e esclarecendo eventuais dúvidas do cliente.</h5>
          <img src={Checklist} alt="foto"></img>
        </div>
        <div className="col-sm-12 col-md-6">
          <h3>Checklist do atendimento:</h3>
          <ListGroup>
            <ListGroup.Item>
              ☑️ Apresentar o plano GigaPlus de 60 megas como uma opção robusta de internet para 
              uso doméstico.
            </ListGroup.Item>
            <ListGroup.Item>
              ☑️ Destacar a velocidade de conexão de 60 megas, ideal para tarefas que exige 
              maior consumo de banda.
            </ListGroup.Item>
            <ListGroup.Item>
              ☑️ Informar que o plano é adequado para até 6 dispositivos conectados simultaneamente.
            </ListGroup.Item>                      
            <ListGroup.Item>
              ☑️ Informar sobre o suporte técnico disponível todos os dias para auxiliar em 
              eventuais problemas.
            </ListGroup.Item>
            <ListGroup.Item>
              ☑️ Apresentar o plano sem fidelidade, cujo valor de instalação é de R$250,00. Nesse 
              plano, o cliente não fica vinculado a um contrato de fidelidade e pode cancelar o 
              serviço a qualquer momento.
            </ListGroup.Item> 
            <ListGroup.Item>
              ☑️ Apresentar o plano com fidelidade, cujo valor de instalação é de R$100,00 e 
              informar que o cliente precisa permanecer na empresa por um período de 1 ano. 
              Caso o cliente deseje cancelar antes desse prazo, será aplicada uma multa de R$450,00 
              por quebra de contrato, essa multa é gradativa e vai diminuindo a cada mês.
            </ListGroup.Item>
            <ListGroup.Item>
              ☑️ Informar que a Gigabyte fornece apenas o modem em comodato. Ao final do contrato 
              o cliente precisa devolver o equipamento em bom estado de conservação e pleno 
              funcionamento.
            </ListGroup.Item>          
            <ListGroup.Item>
              ☑️ Perguntar ao cliente se ele já possui roteador. Se sim, explicar que o roteador 
              precisa ser compatível com a velocidade contratada.
            </ListGroup.Item>
            <ListGroup.Item>
              ☑️ Oferecer ao cliente, caso ele não possua, um dos nossos modelos de roteadores 
              compatíveis com a velocidade contratada.
            </ListGroup.Item>
            <ListGroup.Item>
              ☑️ Afirmar ao cliente que a Gigabyte Telecom é conhecida pela qualidade e confiabilidade
               de seus serviços.
            </ListGroup.Item>
            <ListGroup.Item>
              ☑️ Perguntar se o cliente tem alguma dúvida ou se deseja prosseguir com a contratação 
              do plano GigaPlus.
            </ListGroup.Item>
            <ListGroup.Item>
              ❌ Caso o cliente não queira contratar o plano: Agradecer por considerar nossos serviços! 
              E que estamos à disposição para qualquer outra informação ou necessidade futura que possa 
              surgir. Tenha um ótimo dia!
            </ListGroup.Item>
          </ListGroup>
        </div>
      </div>
      <br />
      <hr />
      <br />
      <ChecklistPurchase />
    </div>
  );
}
export default ResidencialPlus;